export default "__VITE_ASSET__8d8946b1__"